"use client";

import { useOptimistic, useEffect } from "react";
import { useRouter } from "next/navigation";
import { Box, Chip } from "@mui/material";
import Link from "next/link";

/**
 * Category Filter Pills with Optimistic UI
 * Immediately shows selected state while navigation happens in background
 */
export default function CategoryFilterPills({ categories, selectedCategory }) {
  const router = useRouter();
  const [optimisticCategory, setOptimisticCategory] =
    useOptimistic(selectedCategory);

  // Scroll to top when category changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selectedCategory]);

  const handleCategoryClick = (categorySlug) => {
    // Immediately update UI
    setOptimisticCategory(categorySlug);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "0.5rem",
        marginBottom: "1rem",
      }}
    >
      {/* All button */}
      <Link
        href="/blog"
        scroll={false}
        style={{ textDecoration: "none" }}
        onClick={() => handleCategoryClick(null)}
      >
        <Chip
          label="All"
          variant={!optimisticCategory ? "filled" : "outlined"}
          sx={{
            backgroundColor: !optimisticCategory
              ? "primary.main"
              : "transparent",
            color: !optimisticCategory
              ? "primary.contrastText"
              : "text.primary",
            borderColor: "primary.main",
            cursor: "pointer",
            "&:hover": { backgroundColor: "primary.light" },
          }}
        />
      </Link>

      {/* Category buttons */}
      {categories.map((cat) => (
        <Link
          key={cat.id}
          href={`/blog?category=${cat.slug}`}
          scroll={false}
          style={{ textDecoration: "none" }}
          onClick={() => handleCategoryClick(cat.slug)}
        >
          <Chip
            label={cat.name}
            variant={optimisticCategory === cat.slug ? "filled" : "outlined"}
            sx={{
              backgroundColor:
                optimisticCategory === cat.slug
                  ? "primary.main"
                  : "transparent",
              color:
                optimisticCategory === cat.slug
                  ? "primary.contrastText"
                  : "text.primary",
              borderColor: "primary.main",
              cursor: "pointer",
              "&:hover": { backgroundColor: "primary.light" },
            }}
          />
        </Link>
      ))}
    </Box>
  );
}
